import { useContext } from 'react'
import { SmallText } from '@entur/typography'
import { toPrintFormat } from '../../utils/date-utils'
import { EmployeeTicketRightsSyncCards } from '../ticket-rights/sync/ticket-right-sync-card'
import { DisabledContext } from '../../contexts/disable-context'
import { EmploymentDataCard } from './employee-employment-data'
import { useEmployee } from '../../contexts/employee-context'
import { TicketRights } from '../ticket-rights/ticket-rights'
import { EmployeeActivities } from './employee-activities'

const EmployeeTab = () => {
  const { employee } = useEmployee()
  const { disabled } = useContext(DisabledContext)

  let updater = employee.sourceLastUpdate || employee.createdBy
  updater = updater === 'Partner-1' ? 'Entur As' : updater // Hack to username is properly used in backend

  return (
    <div className="employee-tab" data-cy="employee-tab">
      <EmployeeTicketRightsSyncCards />
      <EmploymentDataCard />
      <TicketRights />
      <EmployeeActivities />
      <SmallText className={disabled ? 'disabled' : ''}>
        Sist oppdatert: {updater} ({toPrintFormat(employee.lastUpdate || employee.createdAt)})
      </SmallText>
    </div>
  )
}

export default EmployeeTab
